import React from 'react';
import { AppBar, Toolbar, Typography, Avatar, Box, IconButton, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation } from 'react-router-dom';

const menuItems = [
  { text: 'Home', path: '/' },
  { text: 'About Us', path: '/about' },
  { text: 'Loans', path: '/loans' },
  { text: 'Savings & Investment', path: '/savings-investments' },
  { text: 'Contact Us', path: '/contact' },
  { text: 'Register', path: '/register' },
  { text: 'Sign In', path: '/login' },
];

export default function HeaderBar() {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <AppBar position="static"
      sx={{
        background: 'linear-gradient(90deg, #3b1e6d 0%, #5f2c82 100%)',
        boxShadow: 'none',
        mb: 2,
        zIndex: (theme) => theme.zIndex.drawer + 2000,
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', alignItems: 'center', minHeight: 64 }}>
        <Box display="flex" alignItems="center" gap={2}>
          <Box component="img" src="/logo.jpg" alt="Safenet Bank Logo" sx={{ width: 48, height: 48, borderRadius: '4px' }} />
          <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold', letterSpacing: 1 }}>
            Safenet Bank
          </Typography>
        </Box>
        {/* Desktop menu */}
        <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
          {menuItems.map((item) => (
            <Box key={item.text} component={Link} to={item.path} sx={{ color: location.pathname === item.path ? '#ffd700' : 'white', textDecoration: 'none', display: 'flex', alignItems: 'center', px: 1, py: 0.5, borderRadius: 1, fontWeight: 500, fontSize: '1rem', '&:hover': { background: 'rgba(255,255,255,0.08)' } }}>
              <span style={{ marginLeft: 6 }}>{item.text}</span>
            </Box>
          ))}
        </Box>
        {/* Mobile menu icon */}
        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
          <IconButton color="inherit" onClick={handleMenu}>
            <MenuIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            keepMounted
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            container={document.body}
            PaperProps={{ sx: { zIndex: 3000 } }}
          >
            {menuItems.map((item) => (
              <MenuItem key={item.text} component={Link} to={item.path} selected={location.pathname === item.path} onClick={handleClose} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {item.text}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
